// Position math shared by every hierarchy level + TopicElement +
// TopicExerciseTemplate - ported verbatim from
// exercise-templates/blockList.js's nextPosition()/computeMove() (already
// generic over any {id,position}[] array), plus a thin swapPositions()
// wrapper so callers don't need to know about the {kind,block} entry shape
// that file used for merging two tables - here every collection is single.

export function nextPosition(list) {
    if (!list || list.length === 0) return 0;
    return Math.max(...list.map((item) => item.position || 0)) + 1;
}

// Swapping two items' `position` values inverts their relative order
// regardless of the absolute values involved (works even with gaps).
// Returns the two items with positions already swapped, ready to PUT, or
// null if the move would go past either edge of the (position-sorted) list.
export function computeMove(sortedList, index, direction) {
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= sortedList.length) return null;

    const current = sortedList[index];
    const target = sortedList[targetIndex];
    return [
        { ...current, position: target.position },
        { ...target, position: current.position },
    ];
}

// Stable position+id sort - new siblings created without an explicit
// position all land on 0 (Java int, no default handling on the backend),
// so tiebreak by id keeps freshly-created items in creation order instead
// of jumping around between re-renders.
export function sortByPosition(list) {
    return [...(list || [])].sort((a, b) => {
        const posDiff = (a.position || 0) - (b.position || 0);
        if (posDiff !== 0) return posDiff;
        return (a.id || 0) - (b.id || 0);
    });
}
